import { hexEq } from "@gearbox-protocol/sdk/onchain";
import { useMemo } from "react";
import { useHydratedSDK } from "../../sdk";
export default function useAccount(address) {
    const sdk = useHydratedSDK();
    return useMemo(() => {
        return sdk?.plugins.accounts.accounts.find(a => hexEq(a.creditAccount, address));
    }, [sdk, address]);
}
